import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { RolesAndPermissionsService } from '@core/services/roles-and-permissions.service';
import { TableActions } from '../table.actions';
import { NotificationFacade } from '@core/facades/notification.facade';

@Injectable({
  providedIn: 'root',
})
export class RolesHandler {
  constructor() {}
  rolePermissionService = inject(RolesAndPermissionsService);
  notify = inject(NotificationFacade);

  handleRolesLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.rolePermissionService.getAllRoles().subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'roles',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'roles',
            error: error.message,
          })
        );
      },
    });
  }

  deleteRole(ctx: StateContext<TableStateModel>, action: TableActions.DeleteRole) {
    this.rolePermissionService.deleteRole(action.payload.roleId).subscribe({
        next: () => {
          const state = ctx.getState();
          const roles = state.roles?.data.filter(
            (role) => role.id !== action.payload.roleId
          );
          this.notify.success('Role deleted successfully');
  
          ctx.patchState({
            roles: {
              ...state.roles,
              data: roles,
            },
          } as Partial<TableStateModel>);
        },
        error: (error) => {
          this.notify.error('Error occured while deleting role: ', error);
        },
      });
    }


    filterRolesList(ctx: StateContext<TableStateModel>, action: TableActions.FilterRoleList) {
        return this.rolePermissionService.filterAllRoles(action.payload.filter).subscribe({
            next: (response) => {
              ctx.dispatch(
                new TableActions.LoadTableDataSuccess({
                  tableKey: 'roles',
                  data: response.data?.data,
                  totalCount: response.data?.total_count,
                })
              );
            },
            error: (error) => {
              ctx.dispatch(
                new TableActions.LoadTableDataFailure({
                  tableKey: 'roles',
                  error: error.message,
                })
              );
            },
          });
    }

    updateRolePermission(ctx: StateContext<TableStateModel>, action: TableActions.UpdateRolePermission) {
      const state = ctx.getState();
      // Create a new array with updated role
      const updatedRoles = state.roles?.data.map((role) => {
        if (role.id === action.payload.roleId) {
          // Create a copy of the role to avoid direct mutation
          const updatedRole = { ...role };
          
          if (action.payload.isAdd) {
            // Add the permission if it doesn't already exist
            if (!updatedRole.permissions.includes(action.payload.permission)) {
              updatedRole.permissions = [...updatedRole.permissions, {permission: action.payload.permission}];
            }
          } else {
            // Remove the permission
            updatedRole.permissions = updatedRole.permissions.filter(
              (permission: string) => permission !== action.payload.permission
            );
          }
          return updatedRole;
        }
        return role;
      });
    
      // Patch the state with the new roles array
      ctx.patchState({
        roles: {
          ...state.roles,
          data: updatedRoles
        }
      } as Partial<TableStateModel>);
    }
}

